import { useState } from "react";
import equal from "fast-deep-equal";
import { NewsItem } from "src/models/News";
import DisplayNews from "../software/components/display_news";
import FilterAndSearchNewsFeed from "@/components/software/components/filter_and_search_news_feed";
import { cn } from "@/libs/utils";

type SortBy = "latest" | "featured";

const SORT_OPTIONS: { value: SortBy; labelKey: string }[] = [
  { value: "latest", labelKey: "Latest" },
  { value: "featured", labelKey: "Featured" },
];

export default function NewsPage({
  news,
  categories,
}: {
  news: NewsItem[];
  categories: string[];
}) {
  const [category, setCategory] = useState("all");
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState<SortBy>("latest");

  const filteredByCategory =
    category === "all"
      ? news
      : news.filter((d) => d.category.toLowerCase() === category.toLowerCase());
  const filteredBySearch =
    search === ""
      ? filteredByCategory
      : news.filter(
          (d) =>
            d.title && d.title.toLowerCase().includes(search.toLowerCase()),
        );
  // 기본은 최신순. "Featured" 선택 시 featured 값 내림차순(동률은 최신순).
  const sorted = [...filteredBySearch].sort((a, b) =>
    sortBy === "featured"
      ? (Number(b.featured) || 0) - (Number(a.featured) || 0) ||
        b.releaseTime - a.releaseTime
      : b.releaseTime - a.releaseTime,
  );

  return (
    <>
      <div className={cn("mx-auto flex w-full flex-grow")}>
        <div
          className={"mx-auto w-full max-w-screen-lg px-5 sm:mt-20 md:px-10"}
        >
          <div className={"flex flex-col gap-y-10 sm:flex-row"}>
            <FilterAndSearchNewsFeed
              onUpdate={(update) => {
                if (!equal(update, { category, search })) {
                  setCategory(update.category);
                  setSearch(update.search);
                }
              }}
              categories={["all", ...categories]}
              sortBy={sortBy}
              sortOptions={SORT_OPTIONS}
              onSortChange={(value) => setSortBy(value as SortBy)}
              className={"flex flex-col sm:w-1/3 sm:pr-8"}
            />
            <DisplayNews list={sorted} className={"flex flex-col sm:w-2/3"} />
          </div>
        </div>
      </div>
    </>
  );
}
